// Visi API servisai yra ~/services/api.ts faile
export const useApi = () => {
    const { $apiService } = useNuxtApp();

    return $apiService
}